module.exports = __webpack_public_path__ + "static/media/notification.bbe694c5.svg";